// 首页
import request from '@/utils/request'

// 租赁管理主页························start
// 所有设备数据
export function listRentalDevice(params) {
  return request({
    url: '/v3/asset/listRentalDevice',
    method: 'post',
    data: params
  })
}
// 所有租赁数据
export function pageRentalDeviceDetail(params) {
  return request({
    url: '/v3/asset/pageRentalDeviceDetail',
    method: 'post',
    data: params
  })
}
// 新增租赁设备
export function addRentalDevice(params) {
  return request({
    url: '/v3/asset/addRentalDevice',
    method: 'post',
    data: params
  })
}
// 修改租赁设备
export function updateRentalDevice(params) {
  return request({
    url: '/v3/asset/updateRentalDevice',
    method: 'post',
    data: params
  })
}
// 根据公司id找sn
export function findSnList(params) {
  return request({
    url: '/v3/asset/findSnList',
    method: 'post',
    data: params
  })
}
// 删除设备
export function deleteRentalDevice(params) {
  return request({
    url: '/v3/asset/deleteRentalDevice',
    method: 'post',
    data: params
  })
}
// 租赁管理详情页························start
// 实时数据
export function GetRealTimeData(params) {
  return request({
    url: '/v3/device/mqtt/GetRealTimeData',
    method: 'post',
    data: params
  })
}
// 查询单条锁车记录
export function findLockCarDetailById(params) {
  return request({
    url: '/v3/manager/lockCar/findLockCarDetailById',
    method: 'post',
    data: params
  })
}
// 解锁车辆
export function unLockCar(params) {
  return request({
    url: '/v3/manager/lockCar/unLockCar',
    method: 'post',
    data: params
  })
}
// 锁车
export function addLockCarDetail(params) {
  return request({
    url: '/v3/manager/lockCar/addLockCarDetail',
    method: 'post',
    data: params
  })
}
// 修改锁车记录状态
export function updateLockCarDetailStatus(params) {
  return request({
    url: '/v3/manager/lockCar/updateLockCarDetailStatus',
    method: 'post',
    data: params
  })
}
// 根据id找租赁数据
export function findRentalDeviceById(params) {
  return request({
    url: '/v3/asset/findRentalDeviceById',
    method: 'post',
    data: params
  })
}
// 分页出租记录
export function findRentalDeviceDetailList(params) {
  return request({
    url: '/v3/asset/findRentalDeviceDetailList',
    method: 'post',
    data: params
  })
}
// 新增出租记录
export function addRentalDeviceDetail(params) {
  return request({
    url: '/v3/asset/addRentalDeviceDetail',
    method: 'post',
    data: params
  })
}
// 修改出租记录
export function updateRentalDeviceDetail(params) {
  return request({
    url: '/v3/asset/updateRentalDeviceDetail',
    method: 'post',
    data: params
  })
}
// 分页保养记录
export function findRentalDeviceMaintainList(params) {
  return request({
    url: '/v3/asset/findRentalDeviceMaintainList',
    method: 'post',
    data: params
  })
}
// 新增保养记录
export function addRentalDeviceMaintain(params) {
  return request({
    url: '/v3/asset/addRentalDeviceMaintain',
    method: 'post',
    data: params
  })
}
// 修改保养记录
export function updateRentalDeviceMaintain(params) {
  return request({
    url: '/v3/asset/updateRentalDeviceMaintain',
    method: 'post',
    data: params
  })
}
// ////////////////
export function findGeofenceDeviceList(params) {
  return request({
    url: '/v3/manager/geofence/findGeofenceDeviceList',
    method: 'post',
    data: params
  })
}
// 下拉框客户名称
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
// 公司信息下拉框
export function getList(params) {
  return request({
    url: '/v3/user/company/list',
    method: 'post',
    data: params
  })
}
// 修改电子围栏
export function updateGnssGeofenceStatus(params) {
  return request({
    url: '/v3/manager/geofence/updateGnssGeofenceStatus',
    method: 'post',
    data: params
  })
}
// 设备管理主页························end

// 电子围栏························start
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 新增电子围栏
export function addGnssGeofence(params) {
  return request({
    url: '/v3/manager/geofence/addGnssGeofence',
    method: 'post',
    data: params
  })
}
// 获取电子围栏
export function getGnssGeofenceByMcuId(params) {
  return request({
    url: '/v3/manager/geofence/getGnssGeofenceByMcuId',
    method: 'post',
    data: params
  })
}
// 获取警告信息
export function listWarningPushMsg(params) {
  return request({
    url: '/v3/report/listWarningPushMsg',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getRealTimeInfo2(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo2/' + param.sn,
    method: 'get'
    // params: param
  })
}
// 电子围栏························end

// 轨迹回放························start
export function listLocationData(params) {
  return request({
    url: '/v3/location/listLocationData',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 轨迹回放························end
// 获取设备类型
export const getDeviceMachType = () => {
  return request({
    url: '/v3/manager/deviceMech/machineTypeList2',
    method: 'get'
  })
}
// 获取设备每日使用记录数据--yhub
export const getOdcByDayAndHour = (type, data) => {
  if (type == 'e') {
    return request({
      url: '/v3/report/bms/getOdcByDayAndHour',
      method: 'post',
      data: data
    })
  } else {
    return request({
      url: '/v3/report/getOdcByDayAndHour',
      method: 'post',
      data: data
    })
  }
}
// 租赁概览租赁趋势统计
export const rentalDeviceStatistics = (id) => {
  return request({
    url: '/v3/asset/rentalDeviceStatistics',
    method: 'get'
  })
}
// 租赁概览租赁趋势统计（type：1最近30天、2最近60天、3最近90天、4最近1年）
export const rentalDeviceTrendStatistics = (id) => {
  return request({
    url: '/v3/asset/rentalDeviceTrendStatistics?type=' + id,
    method: 'get'
  })
}
